const APIs = {
  GET_ALL: 'resources/topics',
  GET_SINGLE: 'resources/topics/:id',
}

export default APIs
